/**
 * 浏览器检测函数
 */
import { ready } from "./ready";
import { debounce } from "./debounce";

const plugin = {
  isMobile: false,
  isTouch: false,
  isIos: false,
  isBot: /bot|googlebot|crawler|spider|Seobility|robot|crawling/i.test(navigator.userAgent),
  breakPoint: "",
  biggerThan: [] as Platform[]
};

const devices: [Platform, number][] = [["iphone", 480], ["tablet", 767], ["sm-desktop", 991], ["desktop", 1199]];

/**
 * 
 */
const Broweser: IBrowser = {
  isMobile: () => {
    return plugin.isMobile;
  },
  isTouch: () => {
    return plugin.isTouch;
  },
  isIos: () => {
    return plugin.isIos;
  },
  isBot: () => {
    return plugin.isBot;
  },
  // 如果是小屏幕
  isSmall: () => {
    return "iphone" == plugin.breakPoint || "tablet" == plugin.breakPoint
  },
  // 判断大屏幕
  isBiggerThan: (input: Platform) => {
    return plugin.biggerThan.indexOf(input) !== -1;
  },
  getBreakPoint: () => {
    return plugin.breakPoint
  },
  // window.addEventListener("resize", debounce(window, 200), {
  //     passive: !0
  // })
}

const init = () => {
  let platform: Platform = "desktop";
  plugin.biggerThan = [];
  for (let i = 0; i < devices.length; i++) {
    if (onMatchMedia(devices[i][1])) {
      platform = devices[i][0];
      break
    }
    plugin.biggerThan.push(devices[i][0])
  }
  if (plugin.breakPoint != platform) {
    plugin.breakPoint = platform;
  }
}
ready(() => {
  init();
  const isTouchPoint = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  const matchMedia = window.matchMedia("(hover: none)");
  const isMobile = /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent);
  plugin.isTouch = isTouchPoint && (matchMedia.matches || isMobile);
  plugin.isMobile = "iphone" == plugin.breakPoint;
  plugin.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
})


export const onMatchMedia = (input: string | number) => {
  return window.matchMedia("(max-width: " + input + "px)").matches
}


window.addEventListener('resize', debounce(init, 200), {
  passive: true
})
export default Broweser;